module.exports = __webpack_public_path__ + "static/media/11.2cbc03be.jpg";